import { ColDef, ValueGetterParams } from 'ag-grid-community';
import { CompanyWatchlistTableContent, IndustrySegmentHeader } from '../models/watchlist-company.model';
import { getCellClass } from '../watchlists-table/watchlists-table.config';
import { stringNullComparator } from '@shared/utils/comparator.util';

export const buildCompanyColumnDefs = (headers: IndustrySegmentHeader[]): ColDef<CompanyWatchlistTableContent>[] => {
  const sectorCol = (header: IndustrySegmentHeader): ColDef<CompanyWatchlistTableContent> => {
    const sectorName = header.name;

    return {
      headerName: sectorName,
      headerTooltip: sectorName,

      // Get the sector score from sectorScores object
      valueGetter: (params: ValueGetterParams<CompanyWatchlistTableContent>) => {
        return params.data?.sectorScores?.[sectorName] ?? '';
      },

      cellClass: params => getCellClass(params.value),
      sortable: true,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['reset'],
        maxNumConditions: 1,
        filterOptions: ['contains', 'equals'],
      },
    };
  };

  return [
    {
      headerName: 'Company Name',
      field: 'companyName',
      filter: 'agTextColumnFilter',
      sortable: true,
      comparator: stringNullComparator,
      pinned: 'left',
      width: 200,
      minWidth: 150,
      filterParams: {
        buttons: ['reset'],
        maxNumConditions: 1,
      },
    },
    {
      headerName: 'HQ',
      field: 'hq',
      filter: 'agTextColumnFilter',
      sortable: true,
      filterParams: {
        buttons: ['reset'],
        maxNumConditions: 1,
      },
    },
    ...headers.map(sectorCol),
    {
      headerName: 'Controversy List',
      field: 'controversy',
      sortable: true,
      filter: 'agTextColumnFilter',
      minWidth: 200,
      filterParams: {
        buttons: ['reset'],
      },
    },
    {
      headerName: 'Updated Date',
      field: 'updatedDate',
      filter: 'agDateColumnFilter',
      sortable: true,
      minWidth: 130,
      filterParams: {
        buttons: ['reset'],
        maxNumConditions: 1,
      },
    },
    {
      headerName: 'Valid From',
      field: 'validFrom',
      filter: 'agDateColumnFilter',
      sortable: true,
      minWidth: 130,
      filterParams: {
        buttons: ['reset'],
        maxNumConditions: 1,
      },
    },
  ];
};
